import { useQuery } from "@tanstack/react-query";

import { busVehicleTypeQueryKey } from "../config";
import { fetchBusVehicleTypeCandidates as loadBusVehicleTypeCandidates } from "../service/busVehicleTypeService";
import type { BusVehicleTypeCandidate } from "../types";

/** 对外提供启用车型快照，隐藏请求仓储与后端字段形态。 */
export function fetchBusVehicleTypeCandidates(): Promise<BusVehicleTypeCandidate[]> {
  return loadBusVehicleTypeCandidates();
}

/** 按启停后的实时目录加载候选，调用方可控制是否查询。 */
export function useBusVehicleTypeCandidates(enabled = true) {
  return useQuery({ queryKey: [...busVehicleTypeQueryKey, "candidates"], queryFn: fetchBusVehicleTypeCandidates,
    enabled, staleTime: 0, refetchOnWindowFocus: false });
}
